import { render, staticRenderFns } from "./vkBtn.vue?vue&type=template&id=db1da338&scoped=true"
import script from "./vkBtn.vue?vue&type=script&lang=js"
export * from "./vkBtn.vue?vue&type=script&lang=js"
import style0 from "./vkBtn.vue?vue&type=style&index=0&id=db1da338&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1da338",
  null
  
)

export default component.exports